import { Component, Input, OnChanges, OnInit, Output, EventEmitter } from '@angular/core';
import { Conference } from '../../../shared';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';


@Component({
  selector: 'app-booking-status',
  templateUrl: 'booking-status.component.html',
  styleUrls: ['./booking-status.component.scss']
})
export class BookingStatusomponent implements OnInit, OnChanges {
    @Input() 
    bookingResponse$: Observable<any>;

    conference: Conference;
    bookingStatus: string;
    error: any;

    constructor() {
    }

    ngOnInit() {
        this.bookingStatus = 'processing';
    }

    ngOnChanges() {
        if (this.bookingResponse$) {
            this.bookingResponse$.pipe(
                catchError((error: any) => {
                    this.bookingStatus = 'error';
                    this.error = error;
                    return null;
                })
            ).subscribe(conference => {
                    this.bookingStatus = 'success'
                    this.conference = conference;
            });  
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/hunt/components/booking-status/booking-status.component.ts